(function (angular) {
	'use strict';
	
	angular
		.module('localStorageModule')
		.factory('localStorageFactory', [
			'$window',
			'APP_BASE_PATH',
			localStorageFactoryFunction
		]);
	
	function localStorageFactoryFunction($window, APP_BASE_PATH) {
		
		var factory = {
			getItem : getItem,
			getItemAsBoolean : getItemAsBoolean,
			getItemAsNumber: getItemAsNumber,
			setItem : setItem
		};
		
		return factory;
		
		function getItem(key) {
			if(isLocalStorageSupportedAngular()) {
				var item = $window.localStorage.getItem(key);
				return item === null ? undefined : item;
			}
		}

		function getItemAsBoolean(key) {
			var item = getItem(key);
			if(angular.isDefined(item)) {
				return item === 'true';
			}
			return undefined;
		}

		function getItemAsNumber(key) {
			var item = getItem(key);
			if(angular.isDefined(item)) {
				return parseInt(item);
			}
			return undefined;
		}
		
		function setItem(key, value) {
			if(isLocalStorageSupportedAngular()) {
				$window.localStorage.setItem(key, value);
			}
		}
		
		function isLocalStorageSupportedAngular() {
			var testKey = 'localStorageTest';
			var storage = $window.localStorage;
			try {
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);
			}
			catch(error) {
				
				if(window.mixpanel) {
					mixpanel.track('localStorage.setItem() failed');
				}
				
				return false;
			}
			
			return true;
		}
		
	}
})(window.angular);